'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { sendGTMEventEcommerce } from '../lib/events';
import { GTMEcommerceItem } from '../lib/types';

interface GTMPageViewProps {
  event: 'view_item' | 'view_cart' | 'begin_checkout';
  value?: string;
  coupon?: string;
  items: GTMEcommerceItem[];
}

export function GTMPageView({ event, value, coupon, items }: GTMPageViewProps) {
  const pathname = usePathname();

  useEffect(() => {
    sendGTMEventEcommerce({
      event,
      ecommerce: {
        value,
        coupon,
        items
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
